import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";
import { ThemeContext } from "../logic/themeContext";
import "../style/home.css";
import { ReactComponent as LogoCompleteBlack } from "../mediaSvg/logoCompleteBlack.svg";
import { ReactComponent as LogoCompleteWhite } from "../mediaSvg/logoCompleteWhite.svg";

function Home() {
  const { theme } = useContext(ThemeContext);
  const [mousePosition, setMousePosition] = useState(0);

  // Function to move the button with the mouse
  const handleMouse = (e) => {
    const { clientX } = e; // Get the mouse's X coordinate
    const { left, width } = e.currentTarget.getBoundingClientRect(); // Get container dimensions and position
    const offsetX = clientX - left; // Calculate the offset from the left of the container

    // Restrict the movement to within the container's width
    const maxMovement = width / 2 - 50; // 50 is half the button width
    const position = Math.max(
      Math.min(offsetX - width / 2, maxMovement),
      -maxMovement
    );

    setMousePosition(position); // Center the button
  };

  return (
    <div className="homeContainer" onMouseMove={handleMouse}>
      <div>
        {theme === "dark" ? (
          <LogoCompleteWhite className="mascotCustom" />
        ) : (
          <LogoCompleteBlack className="mascotCustom" />
        )}
        <div className="subtitle">
          <div>
            <h2>Your Personalized Weather App</h2>
            <h3>Check the Forecast Now!</h3>
          </div>
        </div>
        <div>
          <div
            className="circlesContainer"
            style={{ transform: `translateX(${mousePosition}px)` }}
          >
            <div className="square"></div>
            <div className="circleTrasparentLeft circleShadowLeft"></div>
            <Link className="noDecoration" to={"weather"}>
              <button className="btnToWeather">Check Now!</button>
            </Link>
            <div className="circleTrasparentRight circleShadowRight"></div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;
